import React from 'react';
import type { EditorIconProps } from './EditorIconProps';

export const LlamaDesktop = ({
  color = 'currentColor',
  size = 40,
  ...props
}: EditorIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      {...props}
    >
      <g transform="translate(6, 5)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.75008 2.50005C3.05971 2.50005 2.50005 3.05971 2.50005 3.75008V17.5004C2.50005 18.1907 3.05971 18.7504 3.75008 18.7504H23.7505C24.4409 18.7504 25.0005 18.1907 25.0005 17.5004V3.75008C25.0005 3.05971 24.4409 2.50005 23.7505 2.50005H3.75008ZM3.75008 0H23.7505C25.8216 0 27.5006 1.67897 27.5006 3.75008V17.5004C27.5006 19.5715 25.8216 21.2505 23.7505 21.2505H3.75008C1.67897 21.2505 0 19.5715 0 17.5004V3.75008C0 1.67897 1.67897 0 3.75008 0Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.4426 23.2811C21.133 23.2811 21.6927 23.8408 21.6927 24.5311C21.6927 25.2215 21.133 25.7812 20.4426 25.7812L13.9244 25.7812C13.234 25.7812 12.6743 25.2215 12.6743 24.5311L12.6743 20.3336C12.6743 19.6432 13.234 19.0835 13.9244 19.0835C14.6147 19.0835 15.1744 19.6432 15.1744 20.3336L15.1744 23.2811L20.4426 23.2811Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.40599 23.2811C6.71561 23.2811 6.15596 23.8408 6.15596 24.5311C6.15596 25.2215 6.71561 25.7812 7.40598 25.7812L13.9243 25.7812C14.6146 25.7812 15.1743 25.2215 15.1743 24.5311L15.1743 20.3336C15.1743 19.6432 14.6146 19.0835 13.9243 19.0835C13.2339 19.0835 12.6743 19.6432 12.6743 20.3336L12.6743 23.2811L7.40599 23.2811Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

LlamaDesktop.displayName = 'LlamaDesktop';
